import { IValuesCollection } from '../../../_common/platform/ts/appTheme';
import { TabsPosition } from './Interfaces';

export const name: string = 'Tabbed Widget Container';
export const group = 'Layout';
export const moduleName: string = 'pdc-widget-multiple';
export const icon: string = 'folder-close';

export const themeFields = {
    widgetMultipleTabPosition: 'widget-multiple-tab-position',
    widgetMultipleTabIconSize: 'widget-multiple-tab-icon-size'
};

export function getTabsPosition(theme: IValuesCollection): TabsPosition {
    return theme[themeFields.widgetMultipleTabPosition] ?? 'top';
}
